interface Pillar {
  icon: string;
  title: string;
  description: string;
}

const pillars: Pillar[] = [
  {
    icon: 'ri-stack-line',
    title: 'Clean Architecture',
    description: 'Systems are designed with clear separation of concerns, modular components, and well-defined interfaces that ensure maintainability and ease of evolution over time.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Performance Optimization',
    description: 'Every component is built with performance in mind, from efficient data handling to responsive interface design, ensuring smooth and reliable operation at every scale.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'User-Centered Design',
    description: 'Solutions are shaped around real user needs and behaviors, combining thoughtful interaction design with technical excellence to deliver intuitive and effective experiences.',
  },
];

export default function PillarsSection() {
  return (
    <section className="relative py-24 md:py-32 lg:py-40 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-4">
          <span className="text-xs tracking-widest uppercase text-foreground-400" style={{ fontFamily: 'var(--font-label)' }}>
            (approach)
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-16 md:mb-24" style={{ fontFamily: 'var(--font-heading)' }}>
          How we
          <br />
          <span className="text-foreground-400">engineer solutions</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((pillar) => (
            <div
              key={pillar.title}
              className="group bg-background-50 rounded-lg p-8 md:p-10 border border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100/80 mb-6">
                <i className={`${pillar.icon} text-xl text-accent-600`}></i>
              </div>

              <h3 className="text-xl md:text-2xl text-foreground-900 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                {pillar.title}
              </h3>

              <p className="text-foreground-600 text-sm md:text-base leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}